import { render, staticRenderFns, recyclableRender, components } from "./window.vue?vue&type=template&id=6e13a709&"
var renderjs
import script from "./window.vue?vue&type=script&lang=js&"
export * from "./window.vue?vue&type=script&lang=js&"
import style0 from "./window.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/window/window.vue"
export default component.exports